import React from 'react';
import { Col } from 'reactstrap';

import { useSelector } from 'react-redux';
import { userSaleId } from '../../selectors/auth';
import {
  totalLeads,
  totalPositives,
  totalRefused,
  totalSupplierCosts,
} from '../../selectors/sale';

import MiniCard from '../Common/MiniCard';

import { useTranslation } from 'react-i18next';

const SaleMetrics = (props) => {
  const supplierId = useSelector(userSaleId);

  const leads = useSelector(totalLeads);
  const positiveLeads = useSelector(totalPositives);
  const refusedLeads = useSelector(totalRefused);
  const supplierCosts = useSelector(totalSupplierCosts);

  const loading = useSelector((state) => state.DailySaleInsights.loading);

  const { t } = useTranslation();

  let metrics = [
    {
      title: 'Leads',
      text: leads,
      color: 'info',
      icon: 'bx bx-user-pin',
    },
    {
      title: t('Positive'),
      text: positiveLeads,
      color: 'success',
      icon: 'bx bx-user-pin',
    },
    {
      title: t('Refused'),
      text: refusedLeads,
      color: 'danger',
      icon: 'bx bx-user-pin',
    },
    {
      title: t(supplierId ? 'Revenues' : 'Sale Costs'),
      text: `${isFinite(supplierCosts) ? supplierCosts.toFixed(0) : 0} €`,
      color: 'dark',
      icon: 'fas fa-laugh-wink',
      isSensitiveData: true,
    },
  ];

  return (
    <>
      {metrics.map((metric, index) => (
        <Col key={'mainMetric_' + index} xs="12" sm="6" lg>
          <MiniCard {...metric} loading={loading} />
        </Col>
      ))}
    </>
  );
};

export default SaleMetrics;
